import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=b17e5d2e&lang=pug"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=b17e5d2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports